import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  Renderer2,
  SimpleChanges,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppComponent } from 'src/app/app.component';

interface JsonFormValidators {
  min?: number;
  max?: number;
  required?: boolean;
  requiredTrue?: boolean;
  email?: boolean;
  minLength?: number;
  maxLength?: number;
  pattern?: string;
  nullValidator?: boolean;
  ssn?:boolean;
}
interface JsonFormControlOptions {
  min?: string;
  max?: string;
  step?: string;
  icon?: string;
  showCount?: boolean;
  count?: number;
}
interface JsonFormControls {
  name: string;
  label: string;
  value: any;
  type: string;
  placeholder: string;
  infoText?: string;
  helperText?: string;
  options?: JsonFormControlOptions | any;
  required: boolean;
  validators: JsonFormValidators;
  readonly?: boolean;
  optional?: boolean;
}
export interface JsonFormData {
  controls: JsonFormControls[];
}

@Component({
  selector: 'app-json-form',
  templateUrl: './json-form.component.html',
  styleUrls: ['./json-form.component.css', '../../css/common.css'],
})
export class JsonFormComponent implements OnInit, OnChanges {
  @Input()
  formData: FormGroup | any;

  @Input()
  controlsData: JsonFormControls[] = [];

  @Output()
  valueChangeEvent = new EventEmitter<any>();

  @Output() InitializationCompletedEvent = new EventEmitter<any>();
  emailFormat: RegExp = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  isInvalidEmail: boolean = false;

  @Input()
  isQuePage: boolean = false;

  @Input()
  controlWidth: boolean = false;

  buildConfig2: any;
  IsFroalaEditor: boolean = false;

  @Input()
  textAreaCol: number = 30;

  @Input()
  textAreaRows: number = 3;

  @Input()
  customClass: string = "";

  @Input()
  textAreaCounterPositionClass: string = 'rightFloat';
  @Input()
  showTextInfo: boolean = true;

  zipCodeRegexFormat: RegExp = /^(?:\d{5}|\d{9}|\d{5}-\d{4})$/;
  ssnRegexFormat:RegExp = /^(?:\d{9}|\d{3}-\d{2}-\d{4})$/;

  faxRegexFormat:RegExp = /^(?:\d{10}|\d{3}-\d{3}-\d{4})$/;
  isInvalidFax:boolean = false;
  isCalendarOpen = false;

  @Input()
  disableControl: boolean = false;

  isFormLoaded: boolean = false;
  
  constructor(
    private fb: FormBuilder,
    private elementRef: ElementRef,
    private appComponent: AppComponent,
    private renderer: Renderer2,
  ) {}

  ngOnInit(): void {
    this.createForm(this.controlsData);
    var tempFilterData = this.controlsData;
    tempFilterData.forEach((field) => {
      if (field.type === 'date') {
        if (field.options.min) {
          field.options.min = new Date(field.options.min);
        }
        if (field.options.min) {
          field.options.max = new Date(field.options.max);
        }
        if (field.value) {
          field.value = new Date(field.value);
        }
      }
    });
    this.InitializationCompletedEvent.emit();
    setTimeout(() => {
      this.isFormLoaded = true;
    })
  }

  ngOnChanges(changes: SimpleChanges) {}

  ngAfterViewChecked(): void {
    const dateInputs = this.elementRef.nativeElement.querySelectorAll('input[role="combobox"]');
    dateInputs.forEach((input: HTMLElement) => {
      const isOpen = this.elementRef.nativeElement.querySelector('.p-datepicker')?.classList.contains('p-datepicker-visible');
      input.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }


  onDateInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    let value = input.value.replace(/\D/g, '');
    if (value.length >= 3 && value.length <= 4) {
      value = value.substring(0, 2) + '/' + value.substring(2);
    } else if (value.length >= 5) {
      value =
        value.substring(0, 2) +
        '/' +
        value.substring(2, 4) +
        '/' +
        value.substring(4);
    }
    input.value = value;
  }
  createForm(controls: JsonFormControls[]) {
    for (const control of controls) {
      const validatorsToAdd = [];
      for (const [key, value] of Object.entries(control.validators)) {
        switch (key) {
          case 'min':
            validatorsToAdd.push(Validators.min(value));
            break;
          case 'max':
            validatorsToAdd.push(Validators.max(value));
            break;
          case 'required':
            if (value) {
              validatorsToAdd.push(Validators.required);
            }
            break;
          case 'requiredTrue':
            if (value) {
              validatorsToAdd.push(Validators.requiredTrue);
            }
            break;
          case 'email':
            if (value) {
              validatorsToAdd.push(Validators.pattern(this.emailFormat));
            }
            break;
          case 'regex':
            if (value) {
              validatorsToAdd.push(Validators.pattern(value));
            }
            break;
          case 'minLength':
            validatorsToAdd.push(Validators.minLength(value));
            break;
          case 'maxLength':
            validatorsToAdd.push(Validators.maxLength(value));
            break;
          case 'pattern':
            validatorsToAdd.push(Validators.pattern(value));
            break;
          case 'fax':
              validatorsToAdd.push(Validators.pattern(this.faxRegexFormat));
             break;
          case 'ssn':
              validatorsToAdd.push(Validators.pattern(/^(?:\d{9}|\d{3}-\d{2}-\d{4})$/));
              break;
          case 'zip':
              validatorsToAdd.push(Validators.pattern(/^(?:\d{5}|\d{9}|\d{5}-\d{4})$/));
              break;
          case 'nullValidator':
            if (value) {
              validatorsToAdd.push(Validators.nullValidator);
            }
            break;
          default:
            break;
        }
      }
      // Add default currency format validator when type is currency
      if (control.type === 'currency') {
        // Allow up to 9 digits before decimal and up to 2 after
        validatorsToAdd.push(Validators.pattern(/^(\d{0,9}(\.\d{0,2})?|\.\d{0,2})$/));
      }
      this.formData?.addControl(
        control.name,
        this.fb.control(control.value, validatorsToAdd)
      );

      if (control.value && control.value.length > 0 && control.type == 'fax') {
        if (!this.faxRegexFormat.test(control.value)) {
          this.isInvalidFax = true;
        }
      }
      
      if (control.value && control.value.length > 0 && control.type == 'email') {
        if (!this.emailFormat.test(control.value)) {
          this.isInvalidEmail = true;
        }
      }
    }
  }

  ngAfterViewInit() {
    const uiElement = this.elementRef.nativeElement.querySelectorAll(
      '.p-datepicker-trigger'
    );
    uiElement.forEach((element: any) => {
      element.setAttribute('aria-label', 'Toggle Datepicker');
      element.setAttribute('title', 'Datepicker');
      element.setAttribute('role', 'button');
    });

    const paragraphs =
      this.elementRef.nativeElement.querySelectorAll('.dynRequired');
    paragraphs.forEach((span: HTMLElement) => {
      this.renderer.setStyle(span, 'font-size', '14px');
      this.renderer.setStyle(span, 'font-weight', 'normal');
    });

    const img = this.elementRef.nativeElement.querySelectorAll('img');
    img.forEach((p: HTMLElement) => {
      p.setAttribute('alt', 'img');
    });
  }

  onCalendarClick() {
    const calendarPrev =
      this.elementRef.nativeElement.querySelector('.p-datepicker-prev');
    const calendarNext =
      this.elementRef.nativeElement.querySelector('.p-datepicker-next');

    if (calendarPrev) {
      calendarPrev.setAttribute('aria-label', 'prevButton');
    }
    if (calendarNext) {
      calendarNext.setAttribute('aria-label', 'nextButton');
    }
  }

  formatDateToMMDDYYYY(value: any, item: any) {
    if (item.value) {
      var value = item.value.toISOString().split('T')[0];
      value.toString();
      this.modelChangeEvent(value, item);
    }
  }

  modelChangeEvent(value: any, item: any) {
    const data = {
      value: value,
      name: item.name,
    };
    if (item.type == 'textarea') {
      item.options.count = item.validators.maxLength - value.length;
    }
    if (item.type == 'email') {
      this.onKeyUpEmailFormatEvent(value,item);
    }
    if(item.type == 'fax'){
      this.onKeyUpFaxEvent(value,item);
    }
    this.valueChangeEvent.emit(data);
  }

  onKeyUpEmailFormatEvent(event: any, item: any) {
    const data = {
      value: event,
      name: item.name,
    };
    if (event) {
      event.srcElement.value && !this.emailFormat.test(event.srcElement.value)
        ? (this.isInvalidEmail = true)
        : (this.isInvalidEmail = false);
    }
  }

  onKeyUpFaxEvent(event:any,item:any){
    const data = {
      value: event,
      name: item.name,
    };
    if (event) {
      (event.srcElement.value && !this.faxRegexFormat.test(event.srcElement.value)) 
      ? this.isInvalidFax = true 
      : this.isInvalidFax = false;
    }
  }
}
